import { forwardRef, useEffect } from "react";
import { FilteredBox } from "./FilteredBox";

export const QIAdvanceSearch = forwardRef(
  (
    {
      showAdvanceSearch,
      setShowAdvanceSearch,
      advanceSearch,
      setAdvanceSearch,
      AdvanceSearchComponent,
      advanceSearchProps,
      onClearFilter,
      onClearAllFilters,
    },
    ref
  ) => {
    const advanceSearchLabels = {
      plate_number_cont: "Plate Number",
      event_type_cont: "Event Type",
      event_name_cont: "Event Name",
      event_sub_type_cont: "Event Subtype",
      device_name_cont: "Device Name",
      device_imei_cont: "Device IMEI",
      driver_name_cont: "Driver Name",
    };

    // Get all active filters
    const getActiveFilters = () => {
      const filters = [];

      // Add advance search filters
      if (advanceSearch) {
        Object.keys(advanceSearch).forEach((key) => {
          if (advanceSearch[key] && advanceSearch[key].toString().trim() !== "") {
            filters.push({
              key: key,
              type: "advance",
              label: advanceSearchLabels[key] || key,
              value: advanceSearch[key],
              displayText: `${advanceSearchLabels[key] || key}: ${advanceSearch[key]}`,
            });
          }
        });
      }

      return filters;
    };

    const activeFilters = getActiveFilters();
    const hasActiveFilters = activeFilters.length > 0;

    // Handle clearing all filters
    const handleClearAll = () => {
      if (onClearAllFilters) {
        onClearAllFilters();
      }
    };

    const handleAdvanceSearch = (searchData) => {
      if (setAdvanceSearch) {
        setAdvanceSearch(searchData);
      }
    };

    return (
      <>
        {hasActiveFilters && (
          <FilteredBox
            activeFilters={activeFilters}
            onClearFilter={onClearFilter}
            clear={true}
            handleClearAll={handleClearAll}
          />
        )}
        {/* Advanced Search Section for Events */}
        {showAdvanceSearch && AdvanceSearchComponent && (
          <div ref={ref} className="advanced-search-dropdown">
            <AdvanceSearchComponent
              {...advanceSearchProps}
              onSearch={handleAdvanceSearch}
              activeSearch={advanceSearch}
              onClose={() => setShowAdvanceSearch(false)}
            />
          </div>
        )}
      </>
    );
  }
);
